import { useState } from 'react'

const baseUrl = import.meta.env.VITE_BASE_URL
const apiUrl = import.meta.env.VITE_SSO_API
const url = `${baseUrl}/${apiUrl}`

export const useSsoLogin = (provider: string, returnUrl?: string): [boolean, () => void] => {
    const [isLoading, setIsLoading] = useState(false)

    const path = returnUrl ? `${url}/${provider}/login?returnUrl=${returnUrl}` : `${url}/${provider}/login`

    const login = () => {
        setIsLoading(true)

        window.location.replace(path)
    }

    return [!!isLoading, login]
}